import {AlertIcon} from '@primer/octicons-react'
import {Blankslate} from '@primer/react/experimental'
import {clsx} from 'clsx'
import type {ReactNode} from 'react'

import type {ErrorPageEmbeddedProps} from './types'

export type RepositoryFileNotFoundErrorPageProps = {
  repositoryName: string
  repositoryOverviewUrl: string
}

export type RepositoryErrorPageProps = ErrorPageEmbeddedProps & {
  action?: {
    label: string
    url: string
  }
  className?: string
  description: ReactNode
  heading?: ReactNode
  visual?: ReactNode
}

const defaultRepositoryErrorVisual = <AlertIcon size="medium" />

export function RepositoryFileNotFoundErrorPage({
  repositoryName,
  repositoryOverviewUrl,
}: RepositoryFileNotFoundErrorPageProps) {
  return (
    <RepositoryErrorPage
      action={{label: 'Return to the repository overview', url: repositoryOverviewUrl}}
      description={
        <>
          The requested file could not be found in <strong>{repositoryName}</strong>.
        </>
      }
      isEmbedded
    />
  )
}

export function RepositoryErrorPage({
  description,
  action,
  heading = '404 - page not found',
  visual = defaultRepositoryErrorVisual,
  isEmbedded = false,
  className,
}: RepositoryErrorPageProps) {
  const RootElement = isEmbedded ? 'div' : 'main'

  return (
    <RootElement className={clsx(isEmbedded && 'm-3', className)}>
      <Blankslate border>
        <Blankslate.Visual>{visual}</Blankslate.Visual>
        <Blankslate.Heading>{heading}</Blankslate.Heading>
        <Blankslate.Description>{description}</Blankslate.Description>
        {action && <Blankslate.PrimaryAction href={action.url}>{action.label}</Blankslate.PrimaryAction>}
      </Blankslate>
    </RootElement>
  )
}
